import LoginErrorHandlerBase from './login_error_hadler_base';
import {CGP_ERROR_CODES} from '../../../exceptions/cgp_error_codes';
import {GNWP_SOURCES} from '../../../components/external_links/external_links_consts';

export default class PendingActionErrorHandler extends LoginErrorHandlerBase {
    static CLASS = 'PendingActionErrorHandler';

    _handledErrorCode() {
        return CGP_ERROR_CODES.PENDING_ACTION_REQUIRED;
    }

    handle(errorProcessingResult) {
        this.serviceFactory.webLoginService().closeLoginForm();

        this.serviceFactory.openLinkService().openLink({
            source: GNWP_SOURCES.PENDING_LOGIN,
            options: {
                token: errorProcessingResult.loginResponse.data.pendingActionToken
            }
        });

    }
}